// Slim B2B operator strip — thin ribbon promoting /advertise. Hidden on advertise/partner pages.
import { Link, useLocation } from "react-router-dom";

const OperatorStrip = () => {
  const location = useLocation();
  if (["/advertise", "/partners", "/tracking-demo"].includes(location.pathname)) return null;
  return (
    <div
      className="pt-16 bg-gradient-to-r from-amber-500/10 via-slate-900 to-emerald-500/10 border-b border-slate-800"
      data-testid="operator-strip"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 text-xs">
        <span className="text-slate-400">
          <span className="text-amber-300 font-bold mr-1.5">FOR OPERATORS:</span>
          Acquire high-intent sports & casino traffic across 30+ GEOs.
        </span>
        <div className="flex items-center gap-3 shrink-0">
          <Link
            to="/advertise"
            className="text-amber-300 hover:text-amber-200 font-bold whitespace-nowrap"
            data-testid="operator-strip-advertise"
          >
            Advertise With Us →
          </Link>
          <Link
            to="/partners"
            className="hidden sm:inline text-emerald-300 hover:text-emerald-200 font-bold whitespace-nowrap"
            data-testid="operator-strip-partners"
          >
            Partner Signup
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OperatorStrip;
